import { useSelector } from 'react-redux';
import { ColContainer, StyledButton } from '../../StyledComponets';
import { goToOktaLogin } from '../../helpers/utilities';
import { getAppData } from '../../app/environment/environmentSlice';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer';

export default function Login() {
  const appData = useSelector(getAppData);

  return (
    <>
      <div>
        <Header/>
        <ColContainer>
        <div style={{border:'1px solid #D3D3D3', background:'#ECECEC',borderRadius: '5px',padding:'50px'}}>
          <StyledButton
            btnType="primary"
            variant="dark"
            size="lg"
            disabled={false}
            onClick={() => {}}
          >
            Customer Login
          </StyledButton> 
          <StyledButton
            btnType="primary"
            variant="dark"
            size="lg"
            onClick={() => {
              goToOktaLogin(appData);
            }}
          >
            Installer Login
          </StyledButton>
          </div>
        </ColContainer>
        <Footer/>
      </div>
    </>
  );
}
